import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './baseQuery'

export const TAG = {
    CONNECTION: 'Connection',
    DASHBOARD: 'Dashboard',
    ENTITY_SUMMARY: 'EntitySummary',
    SYNC_TIME: 'SyncTime',
    SYNC_RECORDS: 'SyncRecords',
    MANAGED_ENTITY: 'ManagedEntity',
    MAPPING: 'Mapping',
    CONFIGURATION: 'Configuration',
    INTEGRATION_TOKEN: 'IntegrationToken',
    NOTIFICATION: 'Notification',
    CLIENT_USER: 'ClientUser',
    CLIENT_PERMISSION: 'ClientPermission'
}

export const baseApi = createApi({
    reducerPath: 'api',
    baseQuery,
    tagTypes: Object.values(TAG),
    endpoints: () => ({})
})
